export enum ShippingAddressTypeEnum {
  HOME_ADDRESS = 'HOME_ADDRESS',
  IMMEDIATE_TRANSFER = 'IMMEDIATE_TRANSFER',
  OFFICE = 'OFFICE',
}
